import { State } from '@meraki-internal/state';
import { APIClient } from '@innerhive-internal/innerhive-api-client';
import { AppPrincipal } from '../AppPrincipal';
import { AnonymousViewerSessionManager } from './AnonymousViewerSessionManager';
import { CareMapState } from '../../caremap/CareMapState';
import { OrganizationsState } from '../../organizations/OrganizationsState';
import { Logger } from '../../support/Logger';

export interface IAnonymousPromoterState {
    isComplete: boolean;
}

export class AnonymousPromoterState extends State<IAnonymousPromoterState> {
    static inject = () => [
        AppPrincipal,
        AnonymousViewerSessionManager,
        APIClient,
        CareMapState,
        OrganizationsState,
        Logger
    ];
    constructor(
        private principal: AppPrincipal,
        private anonymousSessionManager: AnonymousViewerSessionManager,
        private apiClient: APIClient,
        private careMapState: CareMapState,
        private orgs: OrganizationsState,
        private log: Logger
    ){
        super({
            // promotion isn't done yet because it hasn't been considered yet
            isComplete: false
        });

        if (!this.needsPromotion()) {
            this.setState({ isComplete: true });
        }
    }

    handlePromotion = async () => {
        // this gets called mulitple times by AnonymousPromoter

        if (!this.needsPromotion()) {
            this.setState({ isComplete: true });
            return;
        }

        await this.promote();
    };

    private needsPromotion = () => {
        if (this.principal.tokenType === 'caremap-viewer'){
            return false;
        }
        if (this.orgs.isOrgTeamMember()){
            return false;
        }

        if (!this.anonymousSessionManager.hasSessions()){
            return false;
        }

        return true;
    };

    private promote = async () => {
        try {
            const sessionTokens = this.anonymousSessionManager.getSessions().slice(0);

            const entry = await this.apiClient.entry();

            for (const session_token of sessionTokens){

                // don't try to promote the default anon session
                if (session_token !== 'default') {

                    try {
                        await this.apiClient.post(entry.links.promoteFromAnonymous, { session_token });
                    } catch (e: any) {
                        if (e.status === 409) {
                            this.log.info(`Found expired session token "${session_token}"`);
                        } else {
                            e.message = `Failed to promote session_token "${session_token}": ${e.message}`;
                            this.log.error(e);
                        }
                    }

                }

                await this.anonymousSessionManager.removeSession(session_token);

                // TODO: better handling for expired?
            }

            await this.careMapState.loadWithoutActive();

        } finally {
            // this is in finally block to make sure promotion always completes,
            // otherwise ActiveCareMapProviderV2 leaves us on a blank page forever
            this.setState({
                isComplete: true
            });
        }

        // TODO: if there were more than one, we should set one of them to be recently active so it shows up at the top
        // TODO: we might want a little pop up for them once they get there consider something like /caregiver?welcome-promoted
    };
}
